import React from "react";
import ReactDOM from "react-dom";

import "mdi/css/materialdesignicons.min.css";
import "bootstrap/dist/css/bootstrap.css";

import "react-tabs/style/react-tabs.css";

import "react-contexify/dist/ReactContexify.min.css";

import "./index.css";

import "./style.scss";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
